module.exports = __webpack_public_path__ + "img/logo.165d3908.webp";